import styles from "../styles/pages/tasks.module.css";
import Nav from "../components/Nav";
import GlobalData from "../components/GlobalData";
import { observer } from "mobx-react-lite";
import { useContext, useEffect, useState } from "react";
import { ReactComponent as MoneyIcon } from "../assets/money.svg";
import { ReactComponent as CopyIcon } from "../assets/pages/bonuses/copy.svg";
// import { ReactComponent as StarIcon } from "../assets/star.svg";
import { StoreContext } from "..";
import taskService from "../services/task";
import { Task } from '../models/task';
import Spinner from "../components/Spinner";
import config from "../config";
import moment from "moment";
import { useLocation } from "react-router-dom";
// import BottomModal from "../components/BottomModal";


function Channels() {
  const tg = window.Telegram.WebApp;
  const {appStore} = useContext(StoreContext);
  // const [tasksInfo, setTasksInfo] = useState<null | TaskInfo>(null);
  // const [bottomTaskInfo, setBottomTaskInfo] = useState(false);
  const [dayPromoCodeTime, setDayPromoCodeTime] = useState(0);
  const [progressSubmitTaskId, setProgressSubmitTaskId] = useState<string>("");
  const [getInviteMessageProcess, setGetInviteMessageProcess] = useState(false);
  const location = useLocation();

  const getTaskInfo = async () => {
    const error = () => {
      appStore.addError("При получении задач произошла ошибка, попробуйте позже")
    };

    try {
      const response = await taskService.get();

      if (response.status === 200) {
        appStore.tasksInfo = response.data;
      } else {
        error();
      };
    } catch {
      error();
    };
  };
  
  useEffect(() => {
    // setTasksInfo(null);
    getTaskInfo();  // проанимировать апдейт прогресса также как и остальные
  }, [location.key]);
  
  useEffect(() => {
    getTaskInfo();
  }, []);
  
  let tasks = [] as Task[];

  if (appStore.tasksInfo) {
    tasks = [...appStore.tasksInfo.tasks];
    tasks.sort((a, b) => a.bounty - b.bounty);
  };

  const submitTask = async (taskId: string) => {
    tg.HapticFeedback.impactOccurred("light");

    const error = () => {
      appStore.addError("При подтверждении задания произошла ошибка");
      setProgressSubmitTaskId("");  
      return;
    };
    
    setProgressSubmitTaskId(taskId);
    try {
      const response = await taskService.submit(taskId);
    
      if (response.status !== 200) {
        error();
      };

      if (appStore.tasksInfo === null) {
        return;
      };

      let curTasks = [...appStore.tasksInfo.tasks];
      const taskIndex = curTasks.findIndex(el => el.id === taskId);
      curTasks[taskIndex].submitted = true;
      console.log(curTasks[taskIndex]);
      let curTasksInfo = {...appStore.tasksInfo};
      curTasksInfo.tasks = curTasks;
      appStore.tasksInfo = curTasksInfo;

      appStore.user.balance += curTasks[taskIndex].bounty;
      tg.HapticFeedback.notificationOccurred("success");
    } catch {
      error();
    };

    setProgressSubmitTaskId("");
  };

  const inviteUsers = async () => {
    const getInviteLink = () => {
      const inviteLink = encodeURIComponent(`https://t.me/${config.botUsername}?start=ref_${appStore.user.self_invite_id}`);
      const inviteText = encodeURIComponent("Подписывайся на каналы и получай новых подписчиков в свой канал — бесплатно! 🚀");
      return `https://t.me/share/url?url=${inviteLink}&text=${inviteText}`;
    };
    
    if (tg.platform === 'unknown') {
      appStore.addError("Недоступно на вашей платформе, обратитесь в поддержку");
      return;
    };

    setGetInviteMessageProcess(true);

    try {
      const inviteMessageId = (await taskService.invite()).data.invite_message_id;
      (tg as any).shareMessage(inviteMessageId);      
    } catch {
      const inviteLink = getInviteLink();

      if (tg.platform === 'tdesktop' || tg.platform === 'weba')
        tg.openLink(inviteLink, {try_instant_view: true});
      else
        tg.openTelegramLink(inviteLink);
    } finally {
      setGetInviteMessageProcess(false);
    };
  };
  
  const openTaskPost = (postLink: string) => {
    tg.HapticFeedback.impactOccurred("light");
    tg.openTelegramLink(postLink);
  };

  const copyPromoCode = (promoCode: string) => {
    appStore.addNotify("Промокод успешно скопирован");
    navigator.clipboard.writeText(promoCode);
  };
  
  const updateDayPromoCodeTime = () => {
    const endDayPromoCodeTime = moment.unix(appStore.dayPromoCode.from_unix).add(20, 'minutes');
    const durationPromoCode = moment.duration(endDayPromoCodeTime.diff(moment()));

    setDayPromoCodeTime(durationPromoCode.asMilliseconds());
    return durationPromoCode.asMilliseconds();
  }

  useEffect(() => {
    if (appStore.dayPromoCode) {
      const duration = updateDayPromoCodeTime();
      
      if (duration <= 0) {
        return;
      }

      const interval = setInterval(() => {
        const duration = updateDayPromoCodeTime();
        
        if (duration <= 0) {
          clearInterval(interval);
        }
      }, 500);
    
      return () => clearInterval(interval);
    }
  }, [appStore.dayPromoCode]);

  return <div className={styles.body}>
      <GlobalData/>
      {appStore.tasksInfo &&
        <div className={styles.bonuses}>
          {appStore.dayPromoCode.from_unix && !appStore.dayPromoCode.promo_code_used && dayPromoCodeTime > 0 && 
          <div>
            <span className={styles.bonus_header}>Предложение дня • <span className={styles.destructive}>{moment.utc(dayPromoCodeTime).format("mm:ss")}</span></span>
            <div className={styles.day_promo_code}>
              <div className={styles.promo_code_data}>
                <div className={styles.promo_code_description}>
                  <span className={styles.percent}>+{appStore.dayPromoCode.percent_bonus}%</span>
                  <span className={styles.promo_code_description_text}>промокоинов к пополнению</span>
                </div>
                <div className={styles.promo_code}>
                  <div className={styles.promo_code_field}>
                    <span>ПРОМОКОД</span>
                    <div className={styles.promo_code_field_value}>{appStore.dayPromoCode.promo_code.toUpperCase()}<button onClick={() => copyPromoCode(appStore.dayPromoCode.promo_code.toUpperCase())}><CopyIcon/></button></div>
                  </div>
                  <button onClick={() => appStore.openPaymentWindow(appStore.dayPromoCode.promo_code.toUpperCase())}>Использовать</button>
                </div>
              </div>
            </div>
          </div>}
          <div className={styles.tasks}>
            <span className={styles.bonus_header}>Задания</span>
            <div className={styles.task} style={{borderTop: "solid 0.1px var(--tg-theme-section-separator-color)"}}>
              <div className={styles.info}>
                <span className={styles.name}>Пригласите друзей</span>
                <span className={styles.description}>Начислим 2<MoneyIcon/> за каждого</span>
              </div>
              <button 
                className={styles.active_button} 
                onClick={inviteUsers}
                style={getInviteMessageProcess ? {color: "transparent"} : {}}
              >
                {getInviteMessageProcess && <div className={styles.button_spinner_wrapper}><Spinner/></div>}Пригласить
              </button>
              <span className={styles.progress}>
                {Math.min(appStore.tasksInfo.task_progress["invite"], 20)}/20
              </span>
            </div>
            <div className={styles.task}>
              <div className={styles.info}>
                <span className={styles.name}>Сними видео</span>
                <span className={styles.description}>Начислим 50<MoneyIcon/></span>
              </div>
              <button className={styles.active_button} onClick={() => openTaskPost("https://t.me/PromoMartNews/10")}>Подробнее</button>
            </div>
            {
              tasks.map((task, index) => {
                const taskProgress = appStore.tasksInfo!.task_progress[task.type];
                let activeButton = false;

                if (taskProgress >= task.target && task.submitted === false) {
                  activeButton = true;
                };

                return <div className={styles.task} key={`task_${task.id}`}>
                  <div className={styles.info}>
                    <span className={styles.name}>{task.name}</span>
                    <span className={styles.description}>{task.description}</span>
                  </div>
                  <button className={activeButton ? styles.active_button : styles.submit} disabled={!activeButton || progressSubmitTaskId === task.id} onClick={() => submitTask(task.id)}>
                    {progressSubmitTaskId !== task.id ? (
                      task.submitted ? "Получено" : <>{task.bounty}<MoneyIcon/></>
                    ) : <Spinner/>}
                  </button>
                  <span className={styles.progress}>{Math.min(taskProgress, task.target)}/{task.target}</span>
                </div>
              })
            }
          </div>
        </div>
      }
      {appStore.tasksInfo === null && <div style={{margin: "auto"}} className={styles.spinner_wrapper}><Spinner/></div>}
      <Nav activePage={2}/>
  </div>;
}

export default observer(Channels);